import axios from "axios";

const ApiHostUrl = "https://oderasid.com/";
const ApiPage = "MyWebSite/mainData.php";

// Blogs in Home main Info
export const BlogsHome = async () =>{
    const Respo = await axios.get(ApiHostUrl + ApiPage + "?getBlogsHome=1");
    return Respo.data;
}

// All Blogs
export const AllBlogs = async () =>{
    const Respo = await axios.get(ApiHostUrl + ApiPage + "?getAllBlogs=1");
    return Respo.data;
}

// Blogs main Info 
export const BlogMainInfo = async (id) =>{
    const Respo = await axios.get(ApiHostUrl + ApiPage + "?getBlogsmainInfo=" + id);
    return Respo.data;
}

// Get Inhalte
export const getBlogConntent = async (id) =>{
    const Respo = await axios.get(ApiHostUrl + ApiPage + "?getBlogConntent="+ id);
    return Respo.data;
}

// Get Cate
export const getCategories = async () =>{
    const Respo = await axios.get(ApiHostUrl + ApiPage + "?getCategories=1");
    return Respo.data;
}


// search Blogs
export const searchBlogs = async (searchValue) =>{
    const Respo = await axios.get(ApiHostUrl + ApiPage + "?searchValue=" + searchValue);
    return Respo.data;
}


// search Categories
export const searchCatego = async (searchCateg) =>{
    const Respo = await axios.get(ApiHostUrl + ApiPage + "?searchCateg=" + searchCateg);
    return Respo.data;
}



/*
export const Posttest = async () =>{
    await axios.post(ApiHostUrl + ApiPage , {
        testPost: "Omar shaar"
    }).then(res =>{
        setTimeout(() => {
            console.log(res.data);  
        }, 500);
    });
}
Posttest();
*/


// Is Default?
export const IfDefaultAdmin = async () =>{
    const Respo = await axios.get(ApiHostUrl + "MyWebSite/AddNewAdmin.php" + "?DefaultAdmin=" + 0);
    return Respo.data;
}


export const AddNewAdmin = async (userName , password , mainAdminPassWord) =>{
    const Respo = await axios.post(ApiHostUrl + "MyWebSite/AddNewAdmin.php" , {
        userName: userName ,
        password: password ,
        mainAdminPassWord: mainAdminPassWord
    });
    return Respo.data;
}


export const LogInData = async (userName , password) =>{
    const Respo = await axios.post(ApiHostUrl + "MyWebSite/LogIn.php" , {
        userNameLog: userName ,
        passwordLog: password 
    });
    return Respo.data;
}


export const ResetAdminMainData = async (userName , password , DefaultPass) =>{
    const Respo = await axios.post(ApiHostUrl + "MyWebSite/ResetAdminMainData.php" , {
        NewuserName: userName ,
        Newpassword: password ,
        theDefaultPass : DefaultPass
    });
    return Respo.data;
}






















/////////////////////////////////////////////// {{  Editing  }} //////////////////////////////////////////////////////////////////

export const HomeDataRequest = async ( FileName , ContentData ) =>{
    const Respo = await axios.post("http://www.omarshaar.com/data/editAdmin.php" , {
        FileName: FileName ,
        ContentData : ContentData
    });
    return Respo.data;
}


/*
// Get Home Json File
export const HomeDataFile = async () =>{
    const Respo = await axios.get("https://oderasid.com/MyWebSite/GetJsonFiles/HomeData.php");
    return Respo.data;
}


// Get About me Home Json File 
export const AboutDataH = async () =>{
    const Respo = await axios.get("https://oderasid.com/MyWebSite/GetJsonFiles/AboutDataH.php");
    return Respo.data;
}
*/


export const fetchDataLeb = async () =>{
    const Respo = await axios.get(`${process.env.PUBLIC_URL}/mydata/CVsections.json`);
    return Respo;
}

export const fetchAllDataHome = async (allFiles) =>{
    const Respo = await axios.get(`http://omarshaar.com/mydata/${allFiles}.json`);
    return Respo.data;
}

setTimeout(() => {
    const fetchAllDataHome2 = async (allFiles) =>{
        const Respo = await axios.get(`http://omarshaar.com/mydata/${allFiles}.json`);
        return Respo.data;
    }

    fetchAllDataHome2("HomeData").then(data =>{
        console.log(data);
    })
}, 2000);











